module.exports = __webpack_public_path__ + "img/orderSuccess.13fb5183.png";